import { c as _c } from "react/compiler-runtime";
import { FlexCenter, SkeletonBlock, TableHeader, TableHeaderCell, TextBody, TextLabel } from "@opensea/ui-kit";
import { StacksFilled } from "@opensea/ui-kit/icons";
import { useMemo } from "react";
import { useTranslations } from "use-intl";
import { LISTINGS_FLOW_ITEMS_TABLE_CLASSNAMES } from "./constants";
import { IncrementAllPricesInput } from "./IncrementAllPricesInput";
export const ListingFlowItemsTableHeader = t0 => {
  const $ = _c(49);
  const {
    numItems,
    isReview,
    adjustForFees: t1,
    skeleton
  } = t0;
  const adjustForFees = t1 === undefined ? false : t1;
  const t = useTranslations("wallet.ListingFlowItemsTableHeader");
  let t2;
  bb0: {
    if (numItems === 1 || isReview) {
      let t3;
      if ($[0] !== adjustForFees || $[1] !== t) {
        t3 = adjustForFees ? t("proceeds") : t("listedAs");
        $[0] = adjustForFees;
        $[1] = t;
        $[2] = t3;
      } else {
        t3 = $[2];
      }
      let t4;
      if ($[3] !== t3) {
        t4 = <TextLabel size="2xs">{t3}</TextLabel>;
        $[3] = t3;
        $[4] = t4;
      } else {
        t4 = $[4];
      }
      t2 = t4;
      break bb0;
    }
    if (skeleton) {
      let t3;
      if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <SkeletonBlock className="h-8 w-[90px]" />;
        $[5] = t3;
      } else {
        t3 = $[5];
      }
      t2 = t3;
      break bb0;
    }
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <IncrementAllPricesInput />;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = t3;
  }
  const priceCell = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <StacksFilled size={16} />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== numItems || $[9] !== t) {
    t4 = numItems === 1 ? t("item") : t("items");
    $[8] = numItems;
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== numItems || $[12] !== t4) {
    t5 = <TableHeaderCell className={LISTINGS_FLOW_ITEMS_TABLE_CLASSNAMES.item}><FlexCenter className="gap-2">{t3}<TextBody className="font-sans lowercase">{numItems} {t4}</TextBody></FlexCenter></TableHeaderCell>;
    $[11] = numItems;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t) {
    t6 = t("floor");
    $[14] = t;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t6) {
    t7 = <TableHeaderCell className={LISTINGS_FLOW_ITEMS_TABLE_CLASSNAMES.floor}><TextLabel size="2xs">{t6}</TextLabel></TableHeaderCell>;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t) {
    t8 = t("traitFloor");
    $[18] = t;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t8) {
    t9 = <TableHeaderCell className={LISTINGS_FLOW_ITEMS_TABLE_CLASSNAMES.traitFloor}><TextLabel size="2xs">{t8}</TextLabel></TableHeaderCell>;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t) {
    t10 = t("topOffer");
    $[22] = t;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10) {
    t11 = <TableHeaderCell className={LISTINGS_FLOW_ITEMS_TABLE_CLASSNAMES.topOffer}><TextLabel size="2xs">{t10}</TextLabel></TableHeaderCell>;
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t) {
    t12 = t("cost");
    $[26] = t;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t12) {
    t13 = <TableHeaderCell className={LISTINGS_FLOW_ITEMS_TABLE_CLASSNAMES.cost}><TextLabel size="2xs">{t12}</TextLabel></TableHeaderCell>;
    $[28] = t12;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== adjustForFees || $[31] !== t) {
    t14 = adjustForFees ? t("listedAs") : t("proceeds");
    $[30] = adjustForFees;
    $[31] = t;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t14) {
    t15 = <TableHeaderCell className={LISTINGS_FLOW_ITEMS_TABLE_CLASSNAMES.proceeds}><TextLabel size="2xs">{t14}</TextLabel></TableHeaderCell>;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== priceCell) {
    t16 = <TableHeaderCell className={LISTINGS_FLOW_ITEMS_TABLE_CLASSNAMES.price}>{priceCell}</TableHeaderCell>;
    $[35] = priceCell;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== isReview || $[38] !== numItems) {
    t17 = numItems > 1 && !isReview && <TableHeaderCell className={LISTINGS_FLOW_ITEMS_TABLE_CLASSNAMES.remove} />;
    $[37] = isReview;
    $[38] = numItems;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== t11 || $[41] !== t13 || $[42] !== t15 || $[43] !== t16 || $[44] !== t17 || $[45] !== t5 || $[46] !== t7 || $[47] !== t9) {
    t18 = <TableHeader className="min-h-10 overflow-visible bg-transparent">{t5}{t7}{t9}{t11}{t13}{t15}{t16}{t17}</TableHeader>;
    $[40] = t11;
    $[41] = t13;
    $[42] = t15;
    $[43] = t16;
    $[44] = t17;
    $[45] = t5;
    $[46] = t7;
    $[47] = t9;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  return t18;
};